import Cookies from "js-cookie";

export const getJSONFromLocalStorage = (lsKey: string) => {
  try {
    const lsJsonString = localStorage.getItem(lsKey);
    if (lsJsonString) {
      return JSON.parse(lsJsonString);
    }
  } catch (err) {}

  return null;
};

export const getAuthToken = () => {
  const token = Cookies.get("auth-token");
  if (token) {
    return token;
  }
  return false;
};
